import { AMAZON_ACTIONS, AMAZON_QUERY_PARAMS } from "./constants";

const getAmazonRedirectAction = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(AMAZON_QUERY_PARAMS.ACTION);
};

export const isAmazonRedirectAction = () => {
    const amazonAction = getAmazonRedirectAction();
    return [AMAZON_ACTIONS.ERROR, AMAZON_ACTIONS.CANCEL].includes(amazonAction);
};
